/** @format */

import React, { useState, useRef, useReducer, useMemo, useEffect } from "react";
// TODO: Keeping the comments, to be used when Edit functionality is introduced later
// import { Dropdown } from "primereact/dropdown";
// import { InputText } from "primereact/inputtext";
// import { Chips } from 'primereact/chips';
import { AgGridReact } from "ag-grid-react";
import ActionsCellRenderer from "./ActionsCellRenderer";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { Toast } from "primereact/toast";
import service from "../../utils/service";
// import useGetRegions from "../../hooks/useRegions";
import {
  loadCommodity,
  showDeleteConfirmationDialog,
  setSelectedCommodity,
  showAddEditDialog,
} from "./cocoaCommodityActions";
// TODO: Keeping the comments, to be used when Edit functionality is introduced later
import { /*newCommodity,*/ initialCommodityState, commoditiesReducer } from "./coocaCommodityReducer";

function CocoaCommodities(props) {
  // eslint-disable-next-line
  const [gridApi, setGridApi] = useState(null);

  const [state, dispatch] = useReducer(commoditiesReducer, initialCommodityState);
  const toast = useRef(null);
  const gridRef = useRef(null);
  // const regionsData = useGetRegions()
  // const regions = regionsData.data ? regionsData.data.map(region => {
  //   if (region.region === "SA") {
  //     return {
  //       ...region,
  //       disabled: true
  //     }
  //   }
  //   return {
  //     ...region,
  //     disabled: false
  //   }
  // }) : []
  // TODO: Keeping the comments, to be used when Edit functionality is introduced later
  // const formRef = useRef(null);
  const columnDefs = useMemo(
    () => [
      { field: "name", filter: true },
      {
        headerName: "Symbol",
        field: "symbol",
        filter: true,
        valueFormatter: (params) => params.value,
        tooltipValueGetter: (params) => params.valueFormatted,
      },
      { field: "grade", filter: true },
      { headerName: "Market", field: "market", filter: true },
      { field: "region", filter: true },
      { field: "shortName", filter: true },
      {
        field: "actions",
        cellRenderer: ActionsCellRenderer,
        cellClass: "user__action",
        cellRendererParams: {
          dispatch,
          isFromBarChart: true
        },
      },
    ],
    []
  );
  const defaultColDef = useMemo(
    () => ({
      flex: 1,
    }),
    []
  );
  const getCommodity = () => {
    return service.cra
      .getCraCommodities()
      .then((res) => {
        let data = res.data.length > 0 ? res.data : null;
        dispatch(loadCommodity(data));
      })
      .catch((err) => console.error("error loading", err));
  };
  // TODO: Keeping the comments, to be used when Edit functionality is introduced later
  // eslint-disable-next-line
  // const formatDataForService = (data) => {
  //   const {
  //     id,
  //     grade,
  //     name: commodity,
  //     region,
  //     shortName: commodityShortName,
  //     symbol: commoditySymbol,
  //     market,
  //     ...rest
  //   } = data;
  //   let { regionId } = props.regions.find((reg) => reg.region === region);
  //   let commodityId = {
  //     commodityId: id,
  //   };
  //   return {
  //     ...rest,
  //     ...commodityId,
  //     commodity,
  //     commoditySymbol,
  //     market,
  //     grade,
  //     commodityShortName,
  //     region: {
  //       regionId,
  //     },
  //   };
  // };
  // TODO : to be used when delete commodity is introduced later
  // const deleteCommodity = () => {
  //   const { selectedCommodity } = state;
  //   gridApi.showLoadingOverlay();
  //   service.cra
  //     .deleteCraCommodity(selectedCommodity.id)
  //     .then((data) => {
  //       toast.current.show({
  //         severity: "success",
  //         summary: "Success",
  //         detail: `Commodity ${selectedCommodity.name} Deleted Successfully`,
  //         life: 1000,
  //       });
  //       return getCommodity();
  //     })
  //     .then((data) => {
  //       // toast.current.clear();
  //       gridApi.hideOverlay();
  //     })
  //     .catch((err) => {
  //       gridApi.hideOverlay();
  //       toast.current.show({
  //         severity: "error",
  //         summary: "Error",
  //         detail: `Error Deleting Commodity ${selectedCommodity.name}`,
  //         life: 3000,
  //       });
  //     });
  // };

  const hideUnhideCommodity = () => {
    const { selectedCommodity } = state;
    gridApi.showLoadingOverlay();
    let apiStatus = "";
    if (selectedCommodity.status === "A") {
      apiStatus = "D"
    } else if (selectedCommodity.status === "D") {
      apiStatus = "A"
    }
    service.cra
      .hideUnHideCraCommodity(selectedCommodity.id, apiStatus)
      .then((data) => {
        toast.current.show({
          severity: "success",
          summary: "Success",
          detail: `Commodity ${selectedCommodity.name} Updated Successfully`,
          life: 1000,
        });
        return getCommodity();
      })
      .then((data) => {
        // toast.current.clear();
        gridApi.hideOverlay();
      })
      .catch((err) => {
        gridApi.hideOverlay();
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: `Error Updating Commodity ${selectedCommodity.name}`,
          life: 3000,
        });
      });
  }
  // TODO: Keeping the comments, to be used when Edit functionality is introduced later
  // const createCommodity = () => {
  //   const { selectedCommodity } = state;
  //   gridApi.showLoadingOverlay();
  //   service.cra
  //     .createCraCommodity([formatDataForService(selectedCommodity)])
  //     .then((data) => {
  //       toast.current.show({
  //         severity: "success",
  //         summary: "Success",
  //         detail: `Commodity ${selectedCommodity.name} Created`,
  //         life: 1000,
  //       });
  //       return getCommodity();
  //     })
  //     .then((data) => {
  //       // toast.current.clear();
  //       gridApi.hideOverlay();
  //     })
  //     .catch((err) => {
  //       gridApi.hideOverlay();
  //       toast.current.show({
  //         severity: "error",
  //         summary: `Error Creating Commodity ${selectedCommodity.name}`,
  //         detail: `${err.response.data}`,
  //         life: 3000,
  //       });
  //     });
  // };
  // const updateCommodity = () => {
  //   const { selectedCommodity } = state;
  //   gridApi.doLayout();
  //   gridApi.showLoadingOverlay();
  //   service.cra
  //     .updateCraCommodity(formatDataForService(selectedCommodity))
  //     .then((data) => {
  //       toast.current.show({
  //         severity: "success",
  //         summary: "Success",
  //         detail: `Commodity ${selectedCommodity.name} Updated`,
  //         life: 1000,
  //       });
  //       return getCommodity();
  //     })
  //     .then((data) => {
  //       // toast.current.clear();
  //       gridApi.hideOverlay();
  //     })
  //     .catch((err) => {
  //       gridApi.hideOverlay();
  //       toast.current.show({
  //         severity: "error",
  //         summary: "Error",
  //         detail: `Error Updating Commodity ${selectedCommodity.name}`,
  //         life: 3000,
  //       });
  //     });
  // };
  const discardChanges = () => {
    dispatch(showAddEditDialog(false));
    dispatch(showDeleteConfirmationDialog(false));
    dispatch(setSelectedCommodity({}));
  };
  useEffect(() => {
    getCommodity();
  }, []);
  // TODO: Keeping the comments, to be used when Edit functionality is introduced later
  // const onAdd = (e) => {
  //   dispatch(showAddEditDialog(true));
  //   dispatch(setSelectedCommodity(newCommodity));
  // };
  const onGridReady = (e) => {
    e.api.showLoadingOverlay();
    setGridApi(e.api);
  };
  const getRowNodeId = (data) => data.id;
  // TODO: Keeping the comments, to be used when Edit functionality is introduced later
  // const updateSelectedCommodity = (key, value) => {
  //   let updatedCommodity = {
  //     ...state.selectedCommodity,
  //     [key]: value,
  //   };
  //   dispatch(setSelectedCommodity(updatedCommodity));
  // };

  return (
    <div style={{ marginTop: "1.5rem" }}>
      <Toast ref={toast} baseZIndex={20000} />
      <div
        className='ag-theme-alpine-dark'
        // style={{ height: 'calc(100vh - 80px - 1rem)', width: "100%" }}
        style={{ height: `calc(100vh - 135px - 1.5rem)`, width: "100%", marginBottom: "1rem" }}
      >
        {/* <Button label='Add' onClick={onAdd} className='p-button p-button-sm btn3 mb-3' /> */}
        <div className='clear'></div>
        <AgGridReact
          ref={gridRef}
          defaultColDef={defaultColDef}
          columnDefs={columnDefs}
          rowData={state.commodities}
          getRowNodeId={getRowNodeId}
          overlayNoRowsTemplate='<span style="color: #cccccc">No Rows to Show</span>'
          animateRows={true}
          pagination={true}
          paginationAutoPageSize={true}
          paginationPageSize={10}
          editType='fullRow'
          suppressClickEdit={true}
          onGridReady={onGridReady}
          overlayLoadingTemplate='<span class="ag-overlay-loading-center">Please wait..</span>'
          enableBrowserTooltips={true}
          tooltipShowDelay={0}
        />
      </div>
      <Dialog
        baseZIndex={10001}
        header='Confirmation'
        visible={state.showDeleteConfirmDialog}
        style={{ width: "50vw" }}
        onHide={discardChanges}
        focusOnShow={false}
      >
        <p className='m-0'>Are you sure you want to {state.selectedCommodity.status === "A" ? "hide": null}{state.selectedCommodity.status === "D" ? "unhide": null} the commodity {state.selectedCommodity.name}?</p>
        <div className='spacing1'>
          <Button label='Cancel' onClick={discardChanges} className='p-button p-button-sm btn3' />
          <Button
            label='Confirm'
            onClick={() => {
              hideUnhideCommodity();
              dispatch(showDeleteConfirmationDialog(false));
            }}
            autoFocus
            className='p-button p-button-sm btn3'
          />
        </div>
      </Dialog>
      {/* <Dialog
        baseZIndex={10001}
        header={state.selectedCommodity.id ? "Edit Commodity" : "Add Commodity"}
        visible={state.showInsertEditDialog}
        style={{ width: "65vw" }}
        onHide={discardChanges}
        focusOnShow={false}
        id='cocoa__commodity'
      >
        <form noValidate ref={formRef}>
          <div className='p-fluid formgrid grid'>
            <div className='field col-6'>
              <label htmlFor='name'>Name</label>
              <InputText
                required
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                  }
                }}
                id='name'
                type='text'
                value={state.selectedCommodity.name || ""}
                onChange={(e) => {
                  updateSelectedCommodity(e.target.id, e.target.value);
                }}
              />
            </div>
            <div className='field col-6'>
              <label htmlFor='grade'>Grade</label>
              <InputText
                required
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                  }
                }}
                id='grade'
                type='text'
                value={state.selectedCommodity.grade || ""}
                onChange={(e) => {
                  updateSelectedCommodity(e.target.id, e.target.value);
                }}
              />
            </div>
            {!state.selectedCommodity.id && (
              <>
                <div className='field col-6'>
                  <label htmlFor='region'>Region</label>
                  <Dropdown
                    required
                    id='region'
                    value={state.selectedCommodity.region || ""}
                    options={props.regions}
                    onChange={(e) => {
                      updateSelectedCommodity(e.target.id, e.target.value);
                    }}
                    optionLabel='region'
                    optionValue='region'
                    placeholder='Select a Region'
                  />
                </div>
                <div className='field col-6'>
                  <label htmlFor='symbol'>Symbol</label>
                  <InputText
                    required
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        e.preventDefault();
                      }
                    }}
                    id='symbol'
                    type='text'
                    value={state.selectedCommodity.symbol || ""}
                    onChange={(e) => {
                      updateSelectedCommodity(e.target.id, e.target.value);
                    }}
                  />
                </div>
                <div className='field col-6'>
                  <label htmlFor='market'>Market</label>
                  <InputText
                    required
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        e.preventDefault();
                      }
                    }}
                    id='market'
                    type='text'
                    value={state.selectedCommodity.market || ""}
                    onChange={(e) => {
                      updateSelectedCommodity(e.target.id, e.target.value);
                    }}
                  />
                </div>
              </>
            )}
            <div className='field col-6'>
              <label htmlFor='shortName'>Short Name</label>
              <InputText
                required
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                  }
                }}
                id='shortName'
                type='text'
                value={state.selectedCommodity.shortName || ""}
                onChange={(e) => {
                  updateSelectedCommodity(e.target.id, e.target.value);
                }}
              />
            </div>
          </div>
          <div className='spacing1'>
            <Button
              label='Cancel'
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                discardChanges();
              }}
              className='p-button p-button-sm btn3'
            />
            <Button
              label={state.selectedCommodity.id ? "Update" : "Add"}
              //   disabled={state.selectedCommodity.commodityDetails?.length === 0}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                if (!formRef.current.checkValidity()) {
                  formRef.current.reportValidity();
                } else {
                  if (state.selectedCommodity.id) {
                    updateCommodity();
                  } else {
                    createCommodity();
                  }
                  dispatch(showAddEditDialog(false));
                }
              }}
              autoFocus
              className='p-button p-button-sm btn3'
            />
          </div>
        </form>
      </Dialog> */}
    </div>
  );
}

export default CocoaCommodities;
